import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ActividadForm } from '../../components/ActividadForm.js';
import { Button } from '../../components/ui/Button.js';
import { Card, CardBody, CardHeader, CardTitle } from '../../components/ui/Card.js';
import { FwaApiError } from '../../lib/api.js';
import { useCreateActividad } from '../../lib/queries/actividades.js';

export function ActividadesNew() {
  const navigate = useNavigate();
  const mutation = useCreateActividad();
  const [serverError, setServerError] = useState<string>('');

  return (
    <div className="space-y-4 max-w-2xl">
      <h1 className="text-2xl font-semibold text-gray-900">Nueva actividad</h1>

      <Card>
        <CardHeader>
          <CardTitle>Datos de la actividad</CardTitle>
        </CardHeader>
        <CardBody>
          <ActividadForm
            mode="create"
            onSubmit={(payload) => {
              setServerError('');
              mutation.mutate(payload, {
                onSuccess: (res) => {
                  if ('queuedOffline' in res) {
                    navigate('/outbox');
                    return;
                  }
                  navigate(`/actividades/${res.data.actividad.entity_id}`);
                },
                onError: (err) => {
                  if (err instanceof FwaApiError) {
                    setServerError(err.problem.detail ?? err.problem.title);
                  } else {
                    setServerError(err.message);
                  }
                },
              });
            }}
            isSubmitting={mutation.isPending}
            serverError={serverError}
          />
        </CardBody>
      </Card>

      <Link to="/actividades">
        <Button variant="ghost">← Regresar al listado</Button>
      </Link>
    </div>
  );
}
